<section appScrollTop class="facility-information w-100">
    @if (isLoading) {
        <div class="h-100 d-flex flex-column justify-content-center align-items-center">
            <mat-spinner diameter="40" class="mb-3" />
        </div>
    } @else {
        @if (!facilityInformation.length) {
            <div class="d-flex align-items-center justify-content-center h-100 w-100 position-absolute">
                <app-facility-information-empty />
            </div>
        } @else {
            <div class="facility-info-airports h-100 w-100 d-flex flex-column position-absolute">
                <div [class.background-back]="mobileQuery.matches">
                    <div class="col-6 d-flex align-items-center">
                        <app-back-button class="back">BACK</app-back-button>
                    </div>
                    @if (urlWebSite && mobileQuery.matches) {
                        <div class="url-section mat-subtitle-2 col-6">
                            <a [href]="urlWebSite.url | sanitize: 'resourceUrl'" target="_blank">
                                {{ urlWebSite.name }}
                            </a>
                        </div>
                    }
                </div>
                <div class="locations h-100 d-flex flex-grow-1">
                    <div class="accordion-map col-md-7 col-lg-8 col-xl-9">
                        <app-google-map
                            [markers]="markers"
                            [mapOptions]="mapOptions"
                            (eventOnChangeMarker)="setIndexExpanded($event)"
                        />
                    </div>
                    <div class="accordion-locations col-sm-12 col-md-5 col-lg-4 col-xl-3">
                        @if (urlWebSite && !mobileQuery.matches) {
                            <div class="url-section mat-subtitle-2">
                                <a [href]="urlWebSite.url | sanitize: 'resourceUrl'" target="_blank">
                                    {{ urlWebSite.name }}
                                </a>
                            </div>
                        }
                        @if (!!customerServiceInfo) {
                            <div class="p-4 customer-service">
                                <app-customer-service />
                            </div>
                        }

                        <cdk-accordion class="d-block">
                            @for (item of facilityInformation; let itemIndex = $index; track itemIndex) {
                                <cdk-accordion-item
                                    #mapChildren
                                    #accordionItem="cdkAccordionItem"
                                    class="accordion-item"
                                    role="button"
                                    tabindex="0"
                                    [attr.id]="'accordion-header-' + itemIndex"
                                    [attr.aria-expanded]="accordionItem.expanded"
                                    [attr.aria-controls]="'accordion-body-' + itemIndex"
                                    [expanded]="indexExpanded === itemIndex"
                                >
                                    <div
                                        class="accordion-item-header"
                                        (click)="
                                            accordionItem.toggle(); centerMarker(itemIndex, accordionItem.expanded)
                                        "
                                        tabindex="0"
                                    >
                                        <div class="d-block">
                                            <h2 class="mat-headline-6 title m-0 px-0">
                                                {{ item.airportName || item.airportCode }}
                                            </h2>
                                            <div class="mat-caption address-info px-0">
                                                {{ item.address1 }}
                                            </div>
                                        </div>
                                        <span class="address-info">
                                            @if (accordionItem.expanded) {
                                                <i class="material-icons">arrow_drop_up</i>
                                            }
                                            @if (!accordionItem.expanded) {
                                                <i class="material-icons">arrow_drop_down</i>
                                            }
                                        </span>
                                    </div>
                                    @defer (when accordionItem.expanded) {
                                        <div
                                            role="region"
                                            [style.display]="accordionItem.expanded ? '' : 'none'"
                                            [attr.id]="'accordion-body-' + itemIndex"
                                            [attr.aria-labelledby]="'accordion-header-' + itemIndex"
                                        >
                                            <div class="accordion-item-body">
                                                @if (!!item.operatingHours?.length) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text title-info">Operating Hours</div>
                                                        @for (
                                                            operatingHours of item.operatingHours;
                                                            track operatingHours
                                                        ) {
                                                            <div class="container-operating-hours">
                                                                <div class="text">{{ operatingHours.days }}</div>
                                                                <div class="text-information mat-caption">
                                                                    {{ operatingHours.hour }}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                @if (item.airportCode) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Airport code</div>
                                                        <div class="text-information mat-caption">
                                                            {{ item.airportCode }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (!!item.airlines?.length) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Airlines</div>
                                                        @for (
                                                            airline of item.airlines;
                                                            let airlineIndex = $index;
                                                            track airlineIndex
                                                        ) {
                                                            <div class="text-information mat-caption">
                                                                {{ airline.name }} {{ airline.name }}{{ airline.name
                                                                }}{{ airline.name }}{{ airline.name }}{{ airline.name }}
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                @if (item.phone) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Phone</div>
                                                        <div class="text-information mat-caption">
                                                            {{ item.phone }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (!!item.firmsCode || !!item.externalFirmsCode) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Firms Code</div>
                                                        <div class="text-information mat-caption">
                                                            @if (item.firmsCode) {
                                                                <span>{{ item.firmsCode }} &nbsp;</span>
                                                            }
                                                            @if (item.externalFirmsCode) {
                                                                <span>{{ item.externalFirmsCode }}</span>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                @if (item.email) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Contact Email</div>
                                                        @for (
                                                            email of item.email;
                                                            let emailIndex = $index;
                                                            track emailIndex
                                                        ) {
                                                            <div class="mb-2">
                                                                <a
                                                                    [href]="'mailto:' + email | sanitize: 'url'"
                                                                    class="text-information mat-caption"
                                                                >
                                                                    {{ email }}
                                                                </a>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                @if (item.awbPrefixes) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">AWB Prefixes Handled</div>
                                                        <div class="text-information mat-caption mb-2">
                                                            @for (
                                                                awb of item.awbPrefixes;
                                                                let awbIndex = $index;
                                                                track awbIndex
                                                            ) {
                                                                <li>{{ awb }}</li>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                @if (item.customers) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Customer list</div>
                                                        <div class="customers-list">
                                                            @for (
                                                                customer of item.customers;
                                                                let customerIndex = $index;
                                                                track customerIndex
                                                            ) {
                                                                <div class="text-information mat-caption">
                                                                    {{ customer }}
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                @if (item.address1) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Address</div>
                                                        <div class="text-information mat-caption">
                                                            {{ item.address1 }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (item.address2) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Address 2</div>
                                                        <div class="text-information mat-caption">
                                                            {{ item.address2 }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (item.city) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">City</div>
                                                        <div class="text-information mat-caption">
                                                            {{ item.city }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (item.state) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">State</div>
                                                        <div class="text-information mat-caption">
                                                            {{ item.state }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (item.zip) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Zip</div>
                                                        <div class="text-information mat-caption">
                                                            {{ item.zip }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (item.country) {
                                                    <div class="content-info flex-shrink-1 mt-1 pb-3">
                                                        <div class="text">Country</div>
                                                        <div class="text-information mat-caption">
                                                            {{ item.country }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            @if (mobileQuery.matches && accordionItem.expanded) {
                                                <div id="mapMobile-{{ itemIndex }}" class="mapMobile">
                                                    <app-google-map
                                                        [markers]="markers[itemIndex] && [markers[itemIndex]]"
                                                        [mapOptions]="{ zoom: 12 }"
                                                    />
                                                </div>
                                            }
                                        </div>
                                    } @placeholder {
                                        <div
                                            [attr.id]="'accordion-body-' + itemIndex"
                                            [attr.aria-labelledby]="'accordion-header-' + itemIndex"
                                        ></div>
                                    }
                                </cdk-accordion-item>
                            }
                        </cdk-accordion>
                    </div>
                </div>
            </div>
        }
    }
</section>
